export const iconFontAwesomeMediaplaybackBackwardStep = (
	<i className="fa-solid fa-backward-step"></i>
);
